export type FlagFormValues = {
	description: string;
	followupDate: Date | null;
	followupTime: Date | null;
};

export type FlagFormErrors = {
	description?: string;
	followupDate?: string;
	followupTime?: string;
};

export const INITIAL_VALUES: FlagFormValues = {
	description: "",
	followupDate: null,
	followupTime: null,
};

// Pure, testable validation — errors are derived from values, never stored.
export const validate = ({
	description,
	followupDate,
	followupTime,
}: FlagFormValues): FlagFormErrors => ({
	description: description.trim() ? undefined : "Reason is required.",
	followupDate: followupDate ? undefined : "Follow up date is required.",
	followupTime: followupTime ? undefined : "Follow up time is required.",
});
